import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from 'react-i18next';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import DesktopHeader from '../../../components/desktop-header';
import ErrorComponent from '../../../components/error';
import type { IdDocImageErrorType } from '../../../types';
type DesktopSelfieRetryViewProps = {
  sideName: string;
  errors: IdDocImageErrorType[];
  onSelfieRetake: () => void;
};
const DesktopSelfieRetryView = t0 => {
  const $ = _c(18);
  const {
    sideName,
    errors,
    onSelfieRetake
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.pages.desktop-selfie-retry"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== sideName) {
    t3 = upperFirst(sideName);
    $[2] = sideName;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <DesktopHeader sideName={t3} isSelfie={true} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== errors || $[7] !== sideName) {
    t5 = <div className="flex flex-col justify-center items-center bg-secondary border border-dashed border-primary rounded px-5 min-h-[280px]"><ErrorComponent errors={errors} sideName={sideName} /></div>;
    $[6] = errors;
    $[7] = sideName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onSelfieRetake || $[12] !== t6) {
    t7 = <Button fullWidth={true} onClick={onSelfieRetake} size="large" data-dd-action-name="selfie:retry">{t6}</Button>;
    $[11] = onSelfieRetake;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
    t8 = <>{t2}<div className="flex flex-col gap-6 pb-4">{t4}{t5}{t7}</div></>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default DesktopSelfieRetryView;
function _temp($) {
  return $["take-selfie-again"];
}